module.exports = __webpack_public_path__ + "img/sales_icon.4fbf05a2.png";